import { AbstractModel } from '.';

class model extends AbstractModel {
    endpoint = 'points-category';

    data;

    async getData() {
        if (!this.data) {
            const requestParams = {
                params: {
                    'response-group': 'activity_editor',
                    limit: -1,
                },
            };
            this.data = await this.get(requestParams).then(r => r.data);
        }
        return this.data;
    }
}

export const PointsCategory = new model();
